import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// cc-common imports
import { IconConstants } from 'cc-common';

// devextreme imports
import { DxPopupComponent } from 'devextreme-angular';

// constants imports
import { StringFormatConstants } from '../../../../_constants/string-format-constants';

// model imports
import { AAPUserMetricsDetailInfo } from '../../../_models/workflow-user-metrics/aap-user-metrics-detail-info';
import { AAPUserMetricsDetailResultDto } from '../../../_models/workflow-user-metrics/aap-user-metrics-detail-result-dto';

@Component({
    selector: 'app-workflow-user-metrics-detail',
    templateUrl: './workflow-user-metrics-detail.component.html',
    styleUrls: ['./workflow-user-metrics-detail.component.scss']
})
export class WorkflowUserMetricsDetailComponent implements OnInit {
    @ViewChild('workflowMetricsDetails', { static: false }) workflowMetricsDetails: DxPopupComponent;

    @Input() title: string;
    @Input() metricType: string;
    @Input() detailSource: AAPUserMetricsDetailResultDto[];

    @Output() onClose = new EventEmitter();

    visible = false;
    gridSource: AAPUserMetricsDetailInfo[] = [];
    dateFormat: string;

    iconClose = IconConstants.CLOSE;

    ngOnInit() {
        this.dateFormat = StringFormatConstants.dateFormat;
        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onPopupShown(): void {
        this.workflowMetricsDetails.instance.repaint();

        setTimeout(() => {
            this.prepareMetricDetailSource();
        });
    }

    onPopupClose(): void {
        this.visible = false;
        this.onClose.emit();
    }

    private prepareMetricDetailSource(): void {
        this.gridSource = [];
        this.detailSource.forEach((row) => {
            this.gridSource.push({
                processDate: row.processDate,
                count: row[this.metricType]
            });
        });
    }
}
